import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AugmentedMapMarkerComponent } from './augmented-map-marker.component';
import { MotePipesModule } from '../../pipes/mote-pipes.module';
import { SvgIconModule } from '../svg-icon';
import { AugmentedMapMarkerGroup } from './augmented-map-marker-group';

@NgModule({
    declarations: [AugmentedMapMarkerComponent, AugmentedMapMarkerGroup],
    imports: [
        CommonModule,
        MotePipesModule,
        SvgIconModule
    ],
    exports: [AugmentedMapMarkerComponent, AugmentedMapMarkerGroup]
})
export class AugmentedMapMarkerModule { }
